// Modules
import { gql } from '@apollo/client'

export const CreateLogin = gql`
    mutation createLogin($patient: PatientLogin, $logInfo: LogInfoInput) {
        createLogin(patient: $patient, logInfo: $logInfo) {
            message
        }
    }
`
